import { render, staticRenderFns } from "./TransactionLedgerPage.vue?vue&type=template&id=4d991209&scoped=true&"
import script from "./TransactionLedgerPage.vue?vue&type=script&lang=js&"
export * from "./TransactionLedgerPage.vue?vue&type=script&lang=js&"
import style0 from "./TransactionLedgerPage.vue?vue&type=style&index=0&id=4d991209&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d991209",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\DigitalCreditTransfer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d991209')) {
      api.createRecord('4d991209', component.options)
    } else {
      api.reload('4d991209', component.options)
    }
    module.hot.accept("./TransactionLedgerPage.vue?vue&type=template&id=4d991209&scoped=true&", function () {
      api.rerender('4d991209', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/TransactionLedgerPage.vue"
export default component.exports